import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ICompanyForm, IPersonForm } from 'src/app/interfaces';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-cadastro',
  templateUrl: './cadastro.component.html',
  styleUrls: ['./cadastro.component.css']
})
export class CadastroComponent {

  constructor(private userService: UsersService, private router: Router, private snackBar: MatSnackBar) { }

  signUpPersonForm: IPersonForm = {
    name:'',
    cpf:'',
    address:'',
    city:'',
    state:'',
    phone:'',
    email:'',
    password:'',
  };

  signUpCompanyForm: ICompanyForm = {
    social:'',
    name:'',
    businessCategory:'',
    cnpj:'',
    address:'',
    city:'',
    state:'',
    phone:'',
    email:'',
    password:''
  };

  showPersonForm: boolean = true;
  showCompanyForm: boolean = false;

  handleShowPersonForm() {
    this.showCompanyForm = false;
    this.showPersonForm = true;
  }

  handleShowCompanyForm() {
    this.showPersonForm = false;
    this.showCompanyForm = true;
  }

  hide: boolean = true;
  
  handlePersonForm() {
    this.userService.create(this.signUpPersonForm).subscribe(
      () => {
        this.snackBar.open("Usuário cadastrado com sucesso", "Fechar", {
          duration: 7000,
        })
        this.router.navigate(['/login']);
      },
      error => {
        console.log('error: ', error);
        this.snackBar.open("Usuário não foi cadastrado com sucesso, tente mais tarde", "Fechar", {
          duration: 7000,
        })
      });
  }

  handleCompanyForm() {
    this.userService.create(this.signUpCompanyForm).subscribe(
      () => {
        this.snackBar.open("Usuário cadastrado com sucesso", "Fechar", {
          duration: 7000,
        })
        this.router.navigate(['/login']);
      },
      error => {
        console.log('error: ', error);
        this.snackBar.open("Usuário não foi cadastrado com sucesso, tente mais tarde", "Fechar", {
          duration: 7000,
        })
      });
  }
}
